import React, { useState } from 'react';
import { User, MapPin, Mail, Phone, CheckCircle, Edit3 } from 'react-feather';

export interface ServiceCustomerData {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  distance_to_location?: number | null;
}

interface ServiceCustomerCardProps {
  data: ServiceCustomerData;
  onConfirm: (opts: { smsConsent: boolean }) => void;
  onEdit: () => void;
  disabled?: boolean;
}

const ServiceCustomerCard: React.FC<ServiceCustomerCardProps> = ({
  data,
  onConfirm,
  onEdit,
  disabled = false,
}) => {
  const fullAddress = `${data.address}, ${data.city}, ${data.state} ${data.zip_code}`;
  const [smsConsent, setSmsConsent] = useState(false);

  return (
    <div className="service-request-card service-request-card--customer">
      <div className="service-request-card__header">
        <div className="service-request-card__icon service-request-card__icon--customer">
          <User size={20} />
        </div>
        <h3 className="service-request-card__title">Confirm Your Information</h3>
      </div>

      <div className="service-request-card__content">
        <div className="service-request-card__section">
          <div className="service-request-card__label">
            <User size={16} />
            <span>Name</span>
          </div>
          <div className="service-request-card__value">
            {data.first_name} {data.last_name}
          </div>
        </div>

        <div className="service-request-card__section">
          <div className="service-request-card__label">
            <Mail size={16} />
            <span>Email</span>
          </div>
          <div className="service-request-card__value">{data.email}</div>
        </div>

        <div className="service-request-card__section">
          <div className="service-request-card__label">
            <Phone size={16} />
            <span>Phone</span>
          </div>
          <div className="service-request-card__value">{data.phone}</div>
        </div>

        <div className="service-request-card__section">
          <div className="service-request-card__label">
            <MapPin size={16} />
            <span>Address</span>
          </div>
          <div className="service-request-card__value">{fullAddress}</div>
        </div>

        {data.distance_to_location != null && (
          <div className="service-request-card__distance">
            <MapPin size={14} />
            <span>{data.distance_to_location.toFixed(1)} miles from nearest location</span>
          </div>
        )}

        <label
          className="service-request-card__sms-consent"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginTop: 12,
            padding: '8px 10px',
            background: '#f9fafb',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            fontSize: '0.85rem',
            color: '#1f2937',
            cursor: 'pointer',
          }}
        >
          <input
            type="checkbox"
            checked={smsConsent}
            onChange={(e) => setSmsConsent(e.target.checked)}
            disabled={disabled}
          />
          <span>Text me updates about this request at {data.phone}</span>
        </label>
      </div>

      <div className="service-request-card__actions">
        <button
          className="service-request-card__btn service-request-card__btn--secondary"
          onClick={onEdit}
          disabled={disabled}
          type="button"
        >
          <Edit3 size={16} />
          Edit Information
        </button>
        <button
          className="service-request-card__btn service-request-card__btn--primary"
          onClick={() => onConfirm({ smsConsent })}
          disabled={disabled}
          type="button"
        >
          <CheckCircle size={16} />
          Confirm & Continue
        </button>
      </div>
    </div>
  );
};

export default ServiceCustomerCard;
